<div [ngClass]="className" class="wrap" fxLayout="row">
  <!--    <a *ngFor="let v of buttons" [matTooltip]="v?.tooltip" disabled="{{v.disabled}}" class="md-small" mat-raised-button color="secondary" type="button" (mousedown)="$event.preventDefault()" (click)="onClick(v, $event)">-->
  @for (v of buttons; track v) {
    @if (!v.hidden) {
      <a [matTooltip]="v?.tooltip" disabled="{{v.disabled}}" class="md-small table-button" mat-raised-button type="button" (mousedown)="$event.preventDefault()" (click)="onClick(v, $event)">
        @if (v.showTooltipAsText) {
          <span style="position: relative; top: -8px">
            <mat-icon>{{v.icon}}</mat-icon>
            {{v.tooltip}}
          </span>
        } @else {
          <mat-icon >{{v.icon}}</mat-icon>
        }
      </a>
    }
  }
</div>

